<template>
  <Button
    variant="outline"
    size="icon-sm"
    class="tw:[&_i]:size-4 tw:[&_i]:text-muted-foreground"
  >
    <slot />
  </Button>
</template>

<script setup>
import { Button } from '@/shadcn/components/ui/button/index.js'
</script>
